import { selector } from '@/lib/selectors';
import { isCurrentUserSignaturePendingSelector } from '@/domain/approvals/selectors';
import * as ACL from '@/domain/restriction';

export const isFinancialDocumentSelector = selector(
  isCurrentUserSignaturePendingSelector,
  ACL.isGranted,
  (isCurrentUserSignaturePending: boolean, isGranted: (policy: unknown) => boolean): boolean => {
    const isAclFinancial = isGranted(ACL.IS_WORK_ON_WITH_CURRENT_DOCUMENT_AS_FINANCIAL);
    if (isGranted(ACL.IS_LIMITED_ACCOUNT) || isGranted(ACL.IS_READ_ONLY_ACCOUNTANT) || isGranted(ACL.IS_ACCOUNT)) {
      return isAclFinancial;
    }
    return isAclFinancial && !isCurrentUserSignaturePending;
  },
);
